jQuery(document).ready(function ($) {

  var tela = $(window).width();

  // Inicia as máscaras de campos
  $('.birthday').mask('00/00/0000');
  $('.phone').mask('(00) 00000-0000');
  $('.cpf').mask('00000000000');
  $('.cep').mask('00000000');

  $('a[href^="#"]').on('click', function (event) {
    event.preventDefault(); // Prevent default anchor behavior

    const href = this.getAttribute('href');
    if (href === '#') return;

    const target = $(href);
    if (target.length) {
      const headerHeight = $('header').outerHeight() || 0;
      const offset = 20; // margem entre header e o topo da section
      const scrollTo = Math.max(0, target.offset().top - headerHeight - offset);

      $('html, body').animate({
        scrollTop: scrollTo
      }, 400);
    }
  });

  // Ao carregar a página com âncora na URL (ex: /#rede-credenciada), rolar considerando o header
  if (window.location.hash) {
    const target = $(window.location.hash);
    if (target.length) {
      setTimeout(function () {
        const headerHeight = $('header').outerHeight() || 0;
        const offset = 20;
        const scrollTo = Math.max(0, target.offset().top - headerHeight - offset);
        $('html, body').scrollTop(scrollTo);
      }, 100);
    }
  }

  const $header = $("header"); // Seleciona o header
  const $goToTop = $(".go-to-top"); // Seleciona o botão de "voltar ao topo"
  const headerHeight = $header.outerHeight(); // Obtém a altura do header

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerHeight) {
      $goToTop.addClass("show"); // Adiciona a classe .show
    } else {
      $goToTop.removeClass("show"); // Remove a classe .show
    }
  });

  // Evento de clique para rolar ao topo
  $goToTop.on("click", function (e) {
    e.preventDefault(); // Previne o comportamento padrão
    $("html, body").stop().animate({ scrollTop: 0 }, 500); // Rola suavemente ao topo
  });

  // Evento de movimento do card fixo
  if(tela >= 1024){

    let $section = $("#detalhes-plano.has-sidebar");
    let $card = $(".card-plano");
    let $footer = $("footer"); // Seleciona o rodapé

    if (!$section.length || !$card.length || !$footer.length) return;

    let offset = 100; // Pixels que devem ultrapassar o topo
    let sectionTop = $section.offset().top;

    $(window).on("scroll", function () {
        let scrollPosition = $(window).scrollTop() + offset;
        let footerTop = $footer.offset().top; // Posição do topo do footer
        let cardHeight = $card.outerHeight(); // Altura do card

        if (scrollPosition > sectionTop) {
            let distance = scrollPosition - sectionTop;

            // Verifica se o card ultrapassaria o footer
            let maxTranslate = footerTop - sectionTop - cardHeight - 25;

            if (distance > maxTranslate) {
                distance = maxTranslate; // Mantém o card acima do rodapé
            }

            $card.css("transform", `translateY(${distance}px)`);
        } else {
            $card.css("transform", "translateY(0)");
        }
    });
  }

});

function validarEmail(email) {
    const regex = /^[^\s@]+@([a-zA-Z]+\.)+[a-zA-Z]{2,}$/;
    return regex.test(email);
}

function validarDataNascimento(dataBr) {
  const partes = dataBr.split('/');

  if (partes.length !== 3) return false;

  const [dia, mes, ano] = partes.map(Number);

  // Verifica se os números são válidos
  if (!dia || !mes || !ano) return false;

  // Cria o objeto Date com os componentes
  const nascimento = new Date(ano, mes - 1, dia); // Mês em JS começa do zero
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  nascimento.setHours(0, 0, 0, 0);

  // Verifica se a data gerada corresponde aos valores inseridos
  if (
    nascimento.getDate() !== dia ||
    nascimento.getMonth() !== mes - 1 ||
    nascimento.getFullYear() !== ano
  ) {
    return false; // Data inválida (ex: 31/02/2024)
  }

  // Verifica se não é uma data futura
  return nascimento <= hoje;
}

function validarNomeCompleto(nome) {
  if (typeof nome !== 'string') return false;

  const nomeTrimado = nome.trim();

  // Verifica se tem pelo menos 7 caracteres
  if (nomeTrimado.length < 7) return false;

  // Divide por espaço e remove partes vazias
  const partes = nomeTrimado.split(' ').filter(parte => parte.length > 0);

  // Precisa ter pelo menos dois nomes (nome + sobrenome)
  if (partes.length < 2) return false;

  // Verifica se todas as partes têm pelo menos 2 letras e não terminam com ponto
  const semAbreviacoes = partes.every(parte => parte.length >= 2 && !/\.$/.test(parte));

  return semAbreviacoes;
}

function validarCPF(cpf) {
  // Verifica se o CPF contém apenas números
  if (!/^\d{11}$/.test(cpf)) {
    return false;
  }

  // Elimina CPFs com todos os dígitos iguais (ex: 00000000000, 11111111111, etc)
  if (/^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;

  return resto === parseInt(cpf.charAt(10));
}

function aplicarCaixaAlta(selector) {
  const inputs = document.querySelectorAll(selector);
  
  inputs.forEach(input => {
    input.addEventListener('input', function () {
      this.value = this.value.toUpperCase();
    });
  });
}